<template>
  <div class="d-flex flex-column overflow-hidden h-100">
    <vue-custom-scrollbar
      class="app-content-padding flex-grow-1 overflow-hidden h-100"
    >
      <ts-page-title
        :title="$t('employeeProfile.pageTitle')"
        :breadcrumb="[
          { text: $t('home'), href: '/' },
          {
            text: $t('employeeProfile.pageTitle'),
            href: '/admin/hr/employee-profiles',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
      <ts-loading-banner :loading="waiting">
        <div class="row">
          <div class="col-md-3">
            <profile v-model="model" :validate="errors" class="tw-h-full" />
          </div>
          <div class="col-md-9">
            <ts-panel>
              <ts-panel-wrapper>
                <form class="form-horizontal form-horizontal-text-right">
                  <details-template
                    v-model="model"
                    :validation="errors"
                    class="tw-mb-14 tw-mt-5"
                  />
                  <nssf-template
                    v-model="model"
                    :validation="errors"
                    class="tw-mb-36 tw-mt-5"
                  />
                  <!-- <payroll-template v-model="model" :validation="errors" />
                  <bank-templete v-model="model" :validation="errors" /> -->
                </form>
              </ts-panel-wrapper>
            </ts-panel>
          </div>
        </div>
      </ts-loading-banner>
    </vue-custom-scrollbar>
    <div
      id="footer"
      class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2 tw-sh"
      style="background-color: #e9ecef"
    >
      <ts-button
        @click.prevent="$router.push({ name: 'employee-profile' })"
        :disabled="waiting_new || waiting"
        class="btn-gray"
      >
        {{ $t("cancel") }}</ts-button
      >
      <ts-button
        color="primary"
        outline
        :waiting="waiting_new"
        :disabled="waiting_new || waiting"
        @click.prevent="onSaveAddNew"
      >
        {{ $t("saveAddNew") }}</ts-button
      >
      <ts-button
        color="primary"
        :waiting="waiting"
        :disabled="waiting_new || waiting"
        @click.prevent="onSave"
      >
        {{ $t("save") }}</ts-button
      >
    </div>
  </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import Profile from "./components/profile.vue";
import NssfTemplate from "./components/nssf.vue";
import DetailsTemplate from "./components/detail.vue";
// import PayrollTemplate from "./components/payroll.vue";
// import BankTemplete from "./components/bank.vue";
import { mapActions } from "vuex";
import { Errors } from "form-backend-validation";
import moment from "moment";

export default {
  name: "employeeProfileCreate",
  components: {
    Profile,
    NssfTemplate,
    DetailsTemplate,
    // PayrollTemplate,
    // BankTemplete,
  },
  data() {
    return {
      loading: false,
      waiting: false,
      waiting_new: false,
      errors: new Errors(),
      model: {
        employee_name_kh: null,
        employee_name_en: null,
        sex: null,
        phone: null,
        email: null,
        address: null,
        photo: null,
        hire_date: moment().format("DD-MM-YYYY"),
        card_id: null,
        probation_end_date: moment().add(3, "M").format("DD-MM-YYYY"),
        status_id: 1,
        status_effective_date: moment().format("DD-MM-YYYY"),
        line_manager1: null,
        line_manager2: null,
        shift_id: null,
        pc_date_id: null,
        payment_type_id: null,
        is_tax_responsed_by_company: false,
        is_spouse_dependant: false,
        num_child_dependant: 0,
        nssf_number: null,
        ssn_no: null,
        ssn_issued_date: null,
        ssn_expiry_date: null,
        ssn_issued_at: null,
        position_id: null,
        nationality_id: null,
        date_of_birth: null,
        emp_type_id: 1,
        bank_id: null,
        bank_account_number: null,
        bank_account_name: null,
        status_reason_id: null,
        fp_serial_card: null,
      },
    };
  },
  created() {
    AppOptions.appContentFullHeight = true;
    AppOptions.appContentClass = "p-0";
  },
  methods: {
    ...mapActions("humanResource/employeeProfile", ["getFormViewData"]),
    async fetchFormViewModel() {
      this.waiting = true;
      await this.getFormViewData();
      this.waiting = false;
    },
    async photoUpload(employee_id) {
      if (
        this.model.photo instanceof File ||
        this.model.photo instanceof Blob
      ) {
        let formData = new FormData();
        formData.append("file", this.model.photo);
        formData.append("employee_id", employee_id);
        let response = await this.$store.dispatch(
          "humanResource/employeeProfile/photoUpload",
          formData
        );
        this.model.photo = response;
      }
      return "";
    },
    async onSaveAddNew() {
      this.errors = new Errors();
      this.waiting_new = true;
      this.$store
        .dispatch(
          "humanResource/employeeProfile/store",
          Object.assign({}, this.model)
        )
        .then(async (response) => {
          await this.photoUpload(this.model.employee_id);
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearInput();
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting_new = false;
        });
    },
    async onSave() {
      this.errors = new Errors();
      this.waiting = true;
      this.$store
        .dispatch(
          "humanResource/employeeProfile/store",
          Object.assign({}, this.model)
        )
        .then(async (response) => {
          await this.photoUpload(response.employee_id);
          this.$notify({
            type: "success",
            text: response.message,
          });
          this.clearInput();
          this.$router.push({ name: "employee-profile" });
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    clearInput() {
      (this.model.employee_name_kh = null),
        (this.model.employee_name_en = null),
        (this.model.sex = null),
        (this.model.phone = null),
        (this.model.email = null),
        (this.model.address = null),
        (this.model.photo = null),
        (this.model.hire_date = moment().format("DD-MM-YYYY")),
        (this.model.card_id = null),
        (this.model.probation_end_date = moment()
          .add(3, "M")
          .format("DD-MM-YYYY")),
        (this.model.status_id = null),
        (this.model.status_effective_date = moment().format("DD-MM-YYYY")),
        (this.model.position_id = null),
        (this.model.shift_id = null),
        (this.model.pc_date_id = null),
        (this.model.payment_type_id = null),
        (this.model.is_tax_responsed_by_company = false),
        (this.model.is_spouse_dependant = false),
        (this.model.num_child_dependant = 0),
        (this.model.nssf_number = null),
        (this.model.ssn_no = null),
        (this.model.ssn_issued_date = null),
        (this.model.ssn_expiry_date = null),
        (this.model.ssn_issued_at = null),
        (this.model.nationality_id = null),
        (this.model.date_of_birth = null),
        (this.model.emp_type_id = 1),
        (this.model.status_reason_id = null),
        (this.model.fp_serial_card = null),
        (this.model.line_manager1 = null),
        (this.model.bank_id = null),
        (this.model.bank_account_number = null),
        (this.model.bank_account_name = null),
        (this.model.line_manager2 = null);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchFormViewModel();
    });
  },
  beforeRouteLeave(to, from, next) {
    AppOptions.appContentFullHeight = false;
    AppOptions.appContentClass = "";
    next();
  },
};
</script>
